// src/api/project/projectApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const createProject = async (project_name, user_id, privacy) => {
    return await axios.post(`${API_URL}/projects/create`, { project_name, user_id, privacy });
};

export const getProjects = async (user_id) => {
    return await axios.get(`${API_URL}/projects/list`, { params: { user_id } });
};

export const deleteProject = async (projectId) => {
    return await axios.delete(`${API_URL}/projects/delete/${projectId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
};

export const validateProjectCodes = async (projectCode) => {
    return await axios.post(`${API_URL}/projects/validate`, { projectCode });
};

export const fetchConsumptionData = async (user_id) => {
    return await axios.get(`${API_URL}/projects/get_consumption_details`, { params: { user_id } });
}

export const getPublicAssessments = async () => {
    const endpoint = `${API_URL}/projects/public-assessments`;
    //console.log("Fetching public assessments:", endpoint);
    try {
        const response = await axios.get(endpoint, {
            timeout: 15000,
        });

        // console.log(
        //     "Public assessments loaded successfully:",
        //     response.data
        // );

        return response;
    } catch (error) {
        console.error("Failed to fetch public assessments:", {
            url: endpoint,
            message: error.message,
            status: error.response?.status,
            response: error.response?.data,
        });

        throw error;
    }
};